import {Component} from '@angular/core';
import {Input} from '@angular/core';

const DJVU_EXTENSIONS = ['.djv', '.djvu'];

const PDF_EXTENSIONS = ['.pdf'];

@Component({
    selector: 'file-icon',
    templateUrl: 'file-icon.component.html',
    styleUrls: ['file-icon.component.scss']
})
export class FileIconComponent {

    @Input()
    extension: string;

    @Input()
    unsupported: boolean;

    isDjvu(): boolean {
        return DJVU_EXTENSIONS.indexOf(this.extension) > -1;
    }

    isPdf(): boolean {
        return PDF_EXTENSIONS.indexOf(this.extension) > -1;
    }

    isPicture(): boolean {
        return !this.isUnsupported() && !this.isDjvu() && !this.isPdf();
    }

    isUnsupported(): boolean {
        return this.unsupported;
    }

}